export * from './configs/proxy'
export * from './configs/register-micro-apps'
export * from './middleware/index'
export * from './mock'
export * from './store/micro-module'
